var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcono4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 689.9 563.3",
    style: {
      enableBackground: "new 0 0 689.9 563.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#36504B;}\r\n\t.st1{fill:#A3DDB5;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M342.5,125.3h27.9c12.4,0,22.5-10.1,22.5-22.5s-10.1-22.5-22.5-22.5h-3.8c-1.3-11.2-10.8-19.8-22.3-19.8 c-12.4,0-22.5,10.1-22.5,22.5v1.4c-20.6,8.2-35.2,28.4-35.2,51.9c0,19.4,9.3,36.4,25.1,46.6c12.2,7.9,26.2,13.5,39.2,20 c10,5,6.3,20.7-4.9,20.7h-27.9c-12.4,0-22.5,10.1-22.5,22.5s10.1,22.5,22.5,22.5h3.8c1.3,11.2,10.8,19.8,22.3,19.8 c12.4,0,22.5-10.1,22.5-22.5v-1.4c20.6-8.2,35.2-28.4,35.2-51.9c0-21.7-12.2-39.8-30.9-49.9c0,0-33.4-16.7-33.5-16.7 C327.5,141,331.2,125.3,342.5,125.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M549.9,290.2c-17.5-17.5-46.1-17.5-63.6,0l-66.2,66.2c0-0.7,0.1-1.5,0.1-2.2c0-12-4.7-23.3-13.2-31.7 c-8.5-8.5-19.9-13-31.9-13l-95.7,0.8c-16.1,0.1-25.8,7.6-33.1,15l-52.5,52.5c-5.9-4.9-14.6-4.6-20.2,1L131.2,421 c-2.8,2.8-4.4,6.6-4.4,10.6s1.6,7.8,4.4,10.6l90.5,90.5c2.8,2.8,6.6,4.4,10.6,4.4s7.8-1.6,10.6-4.4l42.3-42.3 c5.5-5.5,5.8-14.1,1.1-20l11.9-11.9l129,0.1c0.1,0,0.2,0,0.3,0c11.6-0.2,22.5-4.9,30.9-13.2l91.6-91.6c8.5-8.5,13.1-19.8,13.1-31.8 C563.1,310,558.4,298.7,549.9,290.2L549.9,290.2z M232.3,500.9L163,431.7l21.1-21.1l69.3,69.3L232.3,500.9z M528.7,332.6 l-91.5,91.5c-2.9,2.9-6.3,4.3-10.2,4.5l-135.1-0.1h0c-4,0-7.8,1.6-10.6,4.4l-16.2,16.2L214.9,399l52.5-52.5c5.3-5.2,8-6.1,12.2-6.2 l95.7-0.8h0.1c3.9,0,7.6,1.5,10.4,4.3c2.8,2.8,4.4,6.5,4.4,10.4c0,3.8-1.5,7.4-4.2,10.1c-2.9,2.9-6.7,4.4-10.8,4.5l-82.6-0.1h0 c-8.3,0-15,6.7-15,15c0,8.3,6.7,15,15,15l121.4,0.1h0c4,0,7.8-1.6,10.6-4.4l83-83c5.8-5.8,15.4-5.8,21.2,0 c2.8,2.8,4.4,6.6,4.4,10.6S531.5,329.8,528.7,332.6L528.7,332.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 27.4,
    cy: 68.1,
    r: 27.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 140.8,
    cy: 20.3,
    r: 20.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 72.8,
    cy: 174.5,
    r: 27.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 565,
    cy: 450.3,
    r: 23.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 660.9,
    cy: 410.4,
    r: 28.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 616.6,
    cy: 534.3,
    r: 28.9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcono4);
export default __webpack_public_path__ + "static/media/icono4.ab98a2cedde8df41e900fc2e18293e79.svg";
export { ForwardRef as ReactComponent };